module.exports = __webpack_public_path__ + "static/media/coconut.d72f8fda.gif";